import {Component, OnDestroy, OnInit} from '@angular/core';
import {MxButtonModel, MxCustomizer, MxFormCustomizerEvent, MxNotificationService, OnBoFormReady} from 'mx-core';
import {FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {PrlLanguageService} from '../../../prl-language/services/prl-language.service';
import {EMPTY, Subject} from 'rxjs';
import {catchError, finalize, tap} from 'rxjs/operators';
import {PrlUnsubscribeService} from '../../services/unsubscribe/prl-unsubscribe.service';

@Component({
    selector: 'prl-unsubscribe',
    templateUrl: './prl-unsubscribe.component.html',
    standalone: false,
    styleUrls: ['prl-unsubscribe.components.scss']
})
export class PrlUnsubscribeComponent implements MxCustomizer<MxFormCustomizerEvent>, OnBoFormReady, OnInit, OnDestroy {
    unsubscribeButton: MxButtonModel;
    affiliate = '';
    token = '';

    private destroy$$: Subject<null> = new Subject<null>();
    private form: FormGroup;
    private requestInProcess = false;

    constructor(
        private readonly unsubscribeService: PrlUnsubscribeService,
        private readonly languageService: PrlLanguageService,
        private readonly notificationService: MxNotificationService,
        private readonly route: ActivatedRoute,
        private readonly router: Router
    ) {
    }

    ngOnInit() {
        this.affiliate = this.route.snapshot.queryParamMap.get('username');
        this.token = this.route.snapshot.queryParamMap.get('token');

        this.unsubscribeButton = {
            label: () => this.getLabel('label.login.unsubscribe.button'),
            permission: 'all',
            tooltip: () => this.getLabel('label.login.unsubscribe.button'),
            className: 'mxs-button--primary',
            disabled: this.requestInProcess,
            clickHandler: this.unsubscribe
        };
    }

    onCustomize(event: MxFormCustomizerEvent): void {
        event
            .customizeProps({
                addPrefixToTitle: false,
                showNavigation: false,
                showErrorOnSubmitInDialog: true,
                closeOnSubmit: true
            })
            .customizeActions({
                submit: {text: 'label.submit', visible: false},
                cancel: {text: 'label.cancel', visible: false}
            })
            .customizeFormMode('new');
        event.addCustomizer(this);

    }

    boOnFormReady(form: FormGroup): void {
        this.form = form;
    }

    ngOnDestroy(): void {
        this.destroy$$.next(null);
    }

    private getLabel(label: string): string {
        return this.languageService.getLabel(label);
    }

    private unsubscribe = () => {
        this.requestInProcess = true;

        this.unsubscribeService
            .unsubscribe(this.affiliate, this.token)
            .pipe(
                tap(success => {
                    if (success) {
                        this.router.navigateByUrl('/account');
                        this.notificationService.showSuccess(
                            'label.login.unsubscribe.success'
                        );
                    } else {
                        this.notificationService.showFailure(
                            'label.errors.error.has.occurred'
                        );
                    }
                }),
                catchError(err => {
                    this.notificationService.showFailure(err.error.detail);
                    return EMPTY;
                }),
                finalize(() => this.requestInProcess = false)
            )
            .subscribe();

    };
}
